import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TabSideBaseClass } from "../../common/tab-side/tab-side.component"
import { Tabs } from "../../common//tabs/tabs.enum";
import { TabsService } from "../../common//tabs/tabs.service";
import { KoblingerService, DatabaseSystem } from "../../koblinger/koblinger.service";
import { ModalService } from "../../services/modal.service";
import { TilgangService } from "../../services/tilgang.service";
import { SystemStatusEnum } from "../../itsystemer/itsystemer.service";
import { throwError } from "rxjs";

@Component({
  selector: "app-systemer-tab",
  templateUrl: "./databasesystemer-tab.component.html"
})
export class DatabaseSystemerTabComponent extends TabSideBaseClass<DatabaseSystem> {

  utgattSystem = SystemStatusEnum.Utgatt;

  tabName(): Tabs {
    return Tabs.systemer;
  }

  constructor(tabsService: TabsService, service: KoblingerService, tilgangService: TilgangService, route: ActivatedRoute, modal: ModalService, router: Router) {
    super(tabsService, service, tilgangService, modal, route, router);
  }

  loaderObservable(service: KoblingerService, id: number): Observable<DatabaseSystem[]> {
    return service.getDatabaseSystemForDatabase(id);
  }

  pageLinkAccess(service: TilgangService): Observable<boolean> {
    return service.getGlobalRoles().pipe(map(val => val.itsystemer.listAccess));
  }

  removeObservable(service: KoblingerService, item: DatabaseSystem): Observable<object> {
    // Kommentert ut 16.april 2026. Skal ikke ha denne funksjonaliteten her lenger.
    //return service.removeDatabaseSystemForDatabase(item.databaseId, item.systemId);
    return throwError(() => new Error('removeObservable er avviklet'));
  }


  compareFn(first: DatabaseSystem, second: DatabaseSystem): number {
    if (first.system?.systemstatusId == second.system?.systemstatusId) return 0;
    if (first.system?.systemstatusId < second.system?.systemstatusId) return -1;
    else return 1;
  }


  
  kobleTil(): void {
    /*
    // Kommentert ut 16.april 2026. Skal ikke ha denne funksjonaliteten her lenger.
    this.modal.velgSystem().then(system => {
      this.modal.velgDatabase().then(database => {

        if (this.liste.some(t => t.systemId === system.systemId && t.databaseId === database.databaseId)) {
          this.modal.warning(`${system.navn} med database ${database.navn} er allerede koblet til database`, "Kobling feilet");
          return;
        }

        // POST endpoint for this is not created in backend as per 16.april 2026.

        const databaseSystem: DatabaseSystem = { databaseId: this.id, systemId: system.systemId };
        this.service.postDatabaseSystemForDatabase(databaseSystem).toPromise().then(() => {
          this.modal.success("System koblet til database", "kobling vellykket");
          this.load();
        });
      });
    });
    */
  }


}
